import loadable from "@loadable/component";

export const Layouts = {
	HeaderFooter: loadable(() => import(`./HeaderFooter`)),
};

export default Layouts;
